import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';

const styles = theme => ({});

const AfitdNumberFormat = props => {
    const { isHidden, prefix = '$', ...otherProps } = props;

    const defns = {
        prefix,
    };

    if (isHidden) {
        return null;
    } else {
        return <NumberFormat {...defns} {...otherProps} />;
    }
};

export default withStyles(styles)(AfitdNumberFormat);
